module.exports = __webpack_public_path__ + "49985940ebbb153dd631b186e21b792d.svg";